export function buttonActionFunc() {
  handleFixedTopButton();
}

function handleFixedTopButton() {
  const topButton = document.querySelector('.l-fixed-button__top');

  if (!topButton) {
    return;
  }

  topButton.addEventListener('click', (event) => {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
